import { useEffect, useRef, useState } from 'react';

export const useGetInstalledRelatedApps = () => {
  const [installedRelatedApps, setInstalledRelatedApps] = useState([]);

  const componentIsMounted = useRef(true);
  useEffect(() => {
    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if ('getInstalledRelatedApps' in navigator) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      (navigator as any)
        .getInstalledRelatedApps()
        .then((apps: any) => {
          if (componentIsMounted.current) {
            setInstalledRelatedApps(apps);
          }
        })
        .catch((err: any) => {
          console.error('Error getting installed related apps:', err);
        });
    }
  }, []);

  return installedRelatedApps;
};
